import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpModule, JsonpModule } from '@angular/http';
import { TooltipModule } from 'ngx-bootstrap';
import { BhtpEditServiceModule } from '@bhtp-client-api/edit';
import { BhtpComponentModule } from '@bhtp-client-web/component';
import { BhtpPurchaseServiceModule } from '@bhtp-client-api/purchase';
import { ApiQuoteRequest, ApiQuoteResponse } from '@bhtp-client-api/base';

import { EditContainerComponent } from './edit-container.component';
import { DataWellComponent } from './data-well.component';
import { EditCoverageListComponent } from './coverages/edit-coverage-list.component';
import { PrimaryTravelerDetailComponent } from './traveler/primary-traveler-detail.component';
import { AdditionalTravelerDetailComponent } from './traveler/additional-traveler-detail.component';
import { TravelersComponent } from './travelers.component';
import { PurchaseModule } from './../purchase/purchase.module';
import { SharedModule } from '../shared/shared.module';
import { FlightEditComponent } from './flight-edit.component';
import { Ng2PageScrollModule } from 'ng2-page-scroll';
import { EditSessionStorage } from './edit-session-storage';
import { EditTripDetailsComponent } from './trip-details';
import { AgentPolicyEditDetailsComponent } from './agent-policy-edit-details.component';

// Exports
export { EditContainerComponent } from './edit-container.component';

@NgModule({
    imports: [
        Ng2PageScrollModule.forRoot(),
        HttpModule,
        JsonpModule,
        CommonModule,
        BhtpEditServiceModule,
        BhtpComponentModule.forRoot(),
        BhtpPurchaseServiceModule,
        PurchaseModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        TooltipModule
    ],
    declarations: [
        EditContainerComponent,
        DataWellComponent,
        TravelersComponent,
        PrimaryTravelerDetailComponent,
        AdditionalTravelerDetailComponent,
        EditCoverageListComponent,
        TravelersComponent,
        FlightEditComponent,
        EditTripDetailsComponent,
        AgentPolicyEditDetailsComponent
    ],
    exports: [
        EditContainerComponent
    ]
})
export class PolicyEditModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/policy-edit.module.ts